module.exports = __webpack_public_path__ + "assets/img/dehydrate_active.e164fc84.png";